import { ApiRequest } from '../../api/request';

export class FeedbackService extends ApiRequest {
  constructor($http, appCache, trackingService) {
    'ngInject';
    super({ $http, appCache, trackingService });
  }

  sendFeedback(feedback) {
    return this.$http({
      method: 'POST',
      data: feedback,
      url: '/api/feedback',
      error: {
        silent: true,
      },
    });
  }

  trackFeedback(feedback, clear) {
    this.trackingService.trackEvent('feedback', {
      category: 'feedback',
      ...feedback
    });

    if (clear) {
      this.clearFeedback();
    }
  }

  storeFeedback(feedback) {
    this.appCache.set('feedback', feedback);
  }

  clearFeedback() {
    this.appCache.remove('feedback');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/ui/feedback/feedback.service.js